export const UNKNOWN_EDIT_MODE = 'unknown';
export const NORMAL_EDIT_MODE = 'normal';
export const GUIDED_EDIT_MODE = 'guided';
